const riot = require('riot');

riot.tag2('module-title-header', '<div class="f fm fbw pb32 border-bottom border-separator_opaque"> <div class="f fm h40 fs18 bold lh15 text-black letter-spacing-0_03em">{opts.title}</div> <div class="h-full"> <yield from="right"></yield> </div> </div>', '', '', function(opts) {
});